import React from "react";
import { inject, observer } from "mobx-react";
import { UploadImage } from '../uploadImage';
import { TagsList } from "./tags";
import { loadFacetVocab } from '../../../services/catalogServiceAPI/facetVocabProxy';
import { WeightedFacetEditor, vocabOptions } from '../../../common/weightedFacetEditor';
import { Card, Input, Select, InputNumber, Button, Space, Divider } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';

/** Weighted facet pickers — styles/rooms/materials/colors, all per primary variation. */
@observer
class FacetsSection extends React.Component {
    state = { facetVocab: null };

    componentDidMount() {
        loadFacetVocab().then(
            (facetVocab) => this.setState({ facetVocab }),
            () => {},
        );
    }

    render() {
        const { facetVocab } = this.state;
        if (!facetVocab) return null;
        const { variation } = this.props;
        return (
            <>
                <WeightedFacetEditor
                    size="small"
                    label="Styles"
                    options={vocabOptions(facetVocab.styles)}
                    value={variation.styles.slice()}
                    onChange={variation.setStyles}
                />
                <WeightedFacetEditor
                    size="small"
                    label="Room types"
                    options={vocabOptions(facetVocab.roomTypes)}
                    value={variation.roomTypes.slice()}
                    onChange={variation.setRoomTypes}
                />
                <WeightedFacetEditor
                    size="small"
                    label="Materials"
                    options={vocabOptions(facetVocab.materials)}
                    value={variation.materials.slice()}
                    onChange={variation.setMaterials}
                />
                <WeightedFacetEditor
                    size="small"
                    label="Color shades"
                    options={vocabOptions(facetVocab.colorShades)}
                    value={variation.colors.slice()}
                    onChange={variation.setColors}
                    defaultWeight={0.5}
                />
            </>
        );
    }
}

const TIER_OPTIONS = [
    { value: 'free', label: 'Free' },
    { value: 'unlockable', label: 'Unlockable' },
    { value: 'premium', label: 'Premium' },
];

@observer
class TierSection extends React.Component {
    render() {
        const { variation, disabled } = this.props;
        return (
            <>
                <Divider style={{ margin: '4px 0' }} />
                <Select
                    size="small"
                    value={variation.accessTier}
                    onChange={variation.setAccessTier}
                    options={TIER_OPTIONS}
                    disabled={disabled}
                    style={{ width: '100%' }}
                />
                {variation.accessTier === 'unlockable' && (
                    <InputNumber
                        size="small"
                        min={1}
                        placeholder="Coin price"
                        value={variation.coinPrice}
                        onChange={variation.setCoinPrice}
                        disabled={disabled}
                        style={{ width: '100%' }}
                        addonBefore="🪙"
                    />
                )}
            </>
        );
    }
}

@observer
export class Variation extends React.Component {
    onTitleChange = ({ target }) => this.props.variation.setTitle(target.value);
    onColorChange = ({ target }) => this.props.variation.setColor(target.value);
    onDelete = () => this.props.onDelete(this.props.variation.id);

    render() {
        const { variation, isPrimary } = this.props;

        return (
            <Card
                size="small"
                style={{ width: 220, flexShrink: 0 }}
                styles={{ body: { padding: '10px 12px' } }}
                extra={
                    <Button
                        icon={<DeleteOutlined />}
                        size="small"
                        danger
                        type="text"
                        onClick={this.onDelete}
                    />
                }
                title={<span style={{ fontSize: 12, opacity: 0.6 }}>{variation.title || 'Unnamed'}</span>}
            >
                <Space direction="vertical" size={6} style={{ width: '100%' }}>
                    <Input
                        size="small"
                        placeholder="Name"
                        value={variation.title}
                        onChange={this.onTitleChange}
                        status={!variation.title ? 'error' : ''}
                    />

                    <UploadImage
                        imageId={variation.imageId}
                        onImageIdChange={variation.setImageId}
                    />

                    <Input
                        size="small"
                        placeholder="Color (RGB)"
                        value={variation.color ?? ''}
                        onChange={this.onColorChange}
                    />

                    <TagsList
                        tags={variation.tags}
                        addTag={variation.addTag}
                        removeTag={variation.removeTag}
                    />

                    {isPrimary && (
                        <>
                            <FacetsSection variation={variation} />
                            <TierSection variation={variation} />
                        </>
                    )}
                </Space>
            </Card>
        );
    }
}
